export const isValid = (date, h1, m1, h2, m2) => {
    var h = date.getHours();
    var m = date.getMinutes();
    return (h1 < h || (h1 == h && m1 <= m)) && (h < h2 || (h == h2 && m <= m2));
};
